import { SxProps } from '@mui/material'
import { swiperClasses } from './Swiper.data'

interface SwiperStyleTypes {
  wrapper: SxProps
  swiperWrapper: SxProps
  headerWrapper: SxProps
}

export const swiperStyles: SwiperStyleTypes = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  swiperWrapper: {
    display: 'flex',

    [`.${swiperClasses.root}`]: {
      margin: 0,
    },
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 1,

    [`&.${swiperClasses.headerClasses.withHeader}`]: {
      mb: 1,
    },
    [`&.${swiperClasses.headerClasses.withAdditionalContent}`]: {
      justifyContent: 'space-between',
    },
  },
}
